import Api from "../../../lib/api";

export const CommentInput = async (contentDetails, commentableId, commentableType, mentions) => {
    let response;
    let content = contentDetails;
    mentions.forEach((mention) => {
        content = content.replaceAll(`@__${mention.name}`, `@__${mention.id}`);
    });
    try {
        return (response = await Api.post("comments", {
            data: {
                type: "comments",
                attributes: {
                    content,
                    commentableId,
                    commentableType,
                },
            },
        }));
    } catch (errors) {
        console.log(errors);
    }
};
